angular.module('tgaApp').service('messagingService',
  ['$window', '$log', 'soundService',
    function messagingService($window, $log, soundService) {
      const sendMsg = (msg) => {
        $window.parent.postMessage(msg, '*');
        $log.debug('messagingService: message sent', msg);
      };

      // set up message EventListener
      $window.addEventListener('message', (ev) => {
        const { data } = ev;
        if (data.type && data.type === 'tga_game_action') {
          this.actionMessageHandler(data);
        }
      });
      // send the current completion percentage of the player and if they
      // have completed the game based on CMS-set criteria
      this.completion = (complete, percent_correct, percent_required, total_questions) => {
        sendMsg({
          type: 'tga_game',
          action: 'completion',
          status: complete ? 'complete' : 'incomplete',
          percent_correct,
          percent_required,
          total_questions,
        });
      };

      // send the score of the player
      this.score = (points, time) => {
        sendMsg({
          type: 'tga_game',
          action: 'score',
          points,
          time,
        });
      };

      // send an answer message
      this.answer = (correct, time) => {
        sendMsg({
          type: 'tga_game',
          action: 'answer',
          status: correct ? 'correct' : 'incorrect',
          time,
        });
      };

      // used when a new game has started
      this.attempt = () => {
        sendMsg({ type: 'tga_game', action: 'attempt' });
      };

      // used when the game over screen is reached
      this.over = () => {
        sendMsg({ type: 'tga_game', action: 'game_over' });
      };

      // used when the close button is used in arcades or SCORM
      this.finish = () => {
        sendMsg({ type: 'tga_game', action: 'game_end' });
      };

      // legacy post messaging
      this.legacyMessaging = ({ score, percent_correct }) => {
        if (angular.isDefined(score)) {
          sendMsg({ type: 'tta', key: 'score', value: score });
        }
        if (angular.isDefined(percent_correct)) {
          sendMsg({ type: 'tta', key: 'percent_correct', value: percent_correct });
        }
      };

      this.actionMessageHandler = (data) => {
        if (!data.action) $log.error('MessagingService: message data is malformed and does not contain an action prop');
        switch (data.action) {
          case 'mute':
            // expecting a boolean, 'false' as a string will read as true
            soundService.masterMute(Boolean(data.value));
            break;
          default:
            $log.error('MessagingService: message data is malformed and does not contain a valid action prop');
            break;
        }
      };
    },
  ]);
